<template>
    <v-card>
        <v-card-title>カルテ</v-card-title>
        <v-card-subtitle>{{ customer.family_name }} {{ customer.given_name }} ({{customer.family_name_kana}} {{customer.given_name_kana}})</v-card-subtitle>
        <v-container fluid>
            <v-row dense>
                <v-col>
                    <v-btn
                        :to="`/customer/${$route.params.id}`"
                    >カルテ
                    </v-btn>
                    <v-btn
                        :to="`/customer/history/${$route.params.id}`"
                    >経緯表
                    </v-btn>
                    <v-btn
                        v-if="customer.gender!=2"
                        :to="`/customer/matching/${$route.params.id}`"
                    >お相手選択
                    </v-btn>
                    <v-btn
                        v-else
                        :to="`/customer/matching_history/${$route.params.id}`"
                    >お相手履歴
                    </v-btn>
                    <v-btn
                        @click="openSheet(customer.sheet_id)"
                        v-if="customer.sheet_id"
                    >旧カルテを開く
                    </v-btn>
                    <v-btn
                        :to="`/customer/file-manager/${$route.params.id}`"
                    >画像管理
                    </v-btn>
                    <v-btn :class="{'pink white--text' : claimFiles.length}"
                           :to="`/customer/claim-manager/${$route.params.id}`"
                    >クレーム管理
                    </v-btn>
                </v-col>
            </v-row>
        </v-container>
        <v-card-text>
            <v-container fluid>
                <v-row dense>
                    <v-col class="font-weight-bold">
                        基本情報
                    </v-col>
                    <v-col class="text-right">
                        <v-btn
                            class="edit"
                            dark
                            :to="`/customer/edit/${$route.params.id}`">
                            編集
                        </v-btn>
                    </v-col>
                </v-row>
                <v-row dense>
                    <v-col cols="6" sm="3" lg="2">
                        <span class="font-weight-bold">支店</span><br>
                        {{customer.shop_name}}
                    </v-col>
                    <v-col cols="6" sm="3" lg="2">
                        <span class="font-weight-bold">フロント</span><br>
                        {{customer.front_name}}
                    </v-col>
                    <v-col cols="6" sm="3" lg="2">
                        <span class="font-weight-bold">クローザー</span><br>
                        {{customer.counselor_name}}
                    </v-col>
                    <v-col cols="6" sm="3" lg="2">
                        <span class="font-weight-bold">担当AD</span><br>
                        {{customer.adviser_name}}
                    </v-col>
                    <v-col cols="6" sm="3" lg="2">
                        <span class="font-weight-bold">手紙送付</span><br>
                        {{customer.valid_mail ? "可" : "不可"}}
                    </v-col>
                    <v-col cols="6" sm="3" lg="2">
                        <span class="font-weight-bold">グレーゾーン</span><br>
                        {{customer.is_grayzone ? "グレーゾーン会員" : "一般会員"}}
                    </v-col>
                </v-row>
                <v-row dense>
                    <v-col cols="6" sm="3" lg="2">
                        <span class="font-weight-bold">性別</span><br>
                        {{CUSTOMER.GENDER.getName(customer.gender)}}
                    </v-col>
                    <v-col cols="6" sm="3" lg="2">
                        <span class="font-weight-bold">血液型</span><br>
                        {{CUSTOMER.BLOOD_TYPE.getName(customer.blood_type)}}型
                    </v-col>
                    <v-col cols="6" sm="3" lg="2">
                        <span class="font-weight-bold">電話番号</span><br>
                        {{customer.phone_number}}
                    </v-col>
                    <v-col cols="6" sm="3" lg="2">
                        <span class="font-weight-bold">自宅番号</span><br>
                        {{customer.phone_number_home}}
                    </v-col>
                    <v-col cols="6" sm="3" lg="2">
                        <span class="font-weight-bold">架電可能曜日</span><br>
                        {{customer.tel_enable_date}}
                    </v-col>
                    <v-col cols="6" sm="3" lg="2">
                        <span class="font-weight-bold">架電可能時間</span><br>
                        {{customer.tel_enable_time}}
                    </v-col>
                </v-row>
                <v-row dense>
                    <v-col cols="6" sm="3" lg="2">
                        <span class="font-weight-bold">生年月日</span><br>
                        {{customer.birthday}} ({{calcAge(customer.birthday)}}歳)
                    </v-col>
                    <v-col cols="6" sm="3" lg="2">
                        <span class="font-weight-bold">メールアドレス</span><br>
                        {{customer.email_address}}
                    </v-col>
                    <v-col cols="12" md="6" lg="4">
                        <span class="font-weight-bold">住所</span><br>
                        〒{{customer.zip}} {{customer.prefectureName}}{{customer.address1}}{{customer.address2}}{{customer.building_name}}
                    </v-col>
                </v-row>
                <v-row dense>
                    <v-col cols="6" sm="3" lg="2">
                        <span class="font-weight-bold">休日</span><br>
                        {{customer.holidays}}
                    </v-col>
                    <v-col cols="6" sm="3" lg="2">
                        <span class="font-weight-bold">年収</span><br>
                        {{customer.income}}
                    </v-col>
                </v-row>
                <v-row dense>
                    <v-col cols="6" sm="3" lg="2">
                        <span class="font-weight-bold">会社名</span><br>
                        {{customer.company_name}}
                    </v-col>
                    <v-col cols="6" sm="3" lg="2">
                        <span class="font-weight-bold">会社名ーふりがな</span><br>
                        {{customer.company_name_kana}}
                    </v-col>
                    <v-col cols="6" sm="3" lg="2">
                        <span class="font-weight-bold">会社郵便番号</span><br>
                        {{customer.company_zip}}
                    </v-col>
                    <v-col cols="6" sm="3" lg="2">
                        <span class="font-weight-bold">会社住所</span><br>
                        {{customer.company_address}}
                    </v-col>
                    <v-col cols="6" sm="3" lg="2">
                        <span class="font-weight-bold">勤務先電話番号</span><br>
                        {{customer.company_tel}}
                    </v-col>
                    <v-col cols="6" sm="3" lg="2">
                        <span class="font-weight-bold">業種</span><br>
                        {{customer.industry}}
                    </v-col>
                    <v-col cols="6" sm="3" lg="2">
                        <span class="font-weight-bold">勤続年数</span><br>
                        {{customer.employment_years}}
                    </v-col>
                </v-row>
                <v-row dense>
                    <v-col cols="12">
                        <span class="font-weight-bold">連盟情報</span>
                    </v-col>
                    <v-col cols="6" sm="3" lg="2">
                        コネクト：{{ customer.connect_federation ? '○' : '×' }}
                    </v-col>
                    <v-col cols="6" sm="3" lg="2">
                        IBJ：{{ customer.ibj_federation ? '○' : '×' }}
                    </v-col>
                </v-row>
            </v-container>
            <v-divider></v-divider>
            <v-container fluid>
                <v-row dense>
                    <v-col class="font-weight-bold">
                        契約情報
                    </v-col>
                    <v-col class="text-right">
                        <v-btn
                            v-if="canAlter()"
                            class="error"
                            @click="alterCourseOpen()">
                            契約情報修正依頼
                        </v-btn>
                        <v-btn
                            class="info"
                            @click="courseOpen()">
                            <span v-if="customer_course_all.length == 0">新規契約追加</span>
                            <span v-else-if="!customer_course">契約追加</span>
                            <span v-else>契約更新</span>
                        </v-btn>
                    </v-col>
                </v-row>
                <div dense v-if="customer_course_all.length > 0">
                    <v-row v-if="customer_course">
                        <v-col cols="6" sm="3" lg="2">
                            <span class="font-weight-bold">現活動コース</span><br>
                            {{getCourseName(customer_course.course_id)}}
                        </v-col>
                        <v-col cols="6" sm="3" lg="2" v-if="customer.contract_date">
                            <span class="font-weight-bold">初入会日</span><br>
                            {{customer.contract_date}}
                        </v-col>
                        <v-col cols="6" sm="3" lg="2" v-if="customer.contract_date">
                            <span class="font-weight-bold">活動年数</span><br>
                            {{customer.year}}
                        </v-col>
                        <v-col cols="6" sm="3" lg="2">
                            <span class="font-weight-bold">最新契約日</span><br>
                            {{customer_course.contract_date}}
                        </v-col>
                    </v-row>
                    <v-row cols="12" v-else>契約切れ</v-row>
                    <v-row>
                        <v-data-table
                            dense
                            :headers="courseHeaders"
                            :items="customer_course_all"
                            :server-items-length="customer_course_all.length"
                            hide-default-footer
                            @click:row="navigateToDetail"
                        >
                            <template v-slot:[`item.course_id`]="{ item }">
                                <span :class="item.is_exists ? 'text-underline' : ''">{{ getListName(courses, item.course_id) }}</span>
                            </template>
                            <template v-slot:[`item.contract_date`]="{ item }">
                                <span :class="item.is_exists ? 'text-underline' : ''">{{ item.contract_date }}</span>
                            </template>
                            <template v-slot:[`item.end_date`]="{ item }">
                                <span :class="item.is_exists ? 'text-underline' : ''">{{ item.end_date }}</span>
                            </template>
                            <template v-slot:[`item.action`]="{ item }">
                                <v-btn 
                                    small class="info" 
                                    style="position: absolute; transform: translateY(-50%) translateX(40%);" 
                                    v-if="canEditContract(item) && item.is_exists" @click.stop="moveToEditContract(item)"
                                >編集</v-btn>
                                <v-btn 
                                    small class="delete" dark
                                    style="position: absolute; transform: translateY(-50%) translateX(150%);" 
                                    v-if="canEditContract(item) && item.is_exists" @click.stop="showCourseDialog(item.id)"
                                >削除</v-btn>
                            </template>
                        </v-data-table>
                    </v-row>
                </div>
                <v-row dense v-else>
                    <v-col>未契約</v-col>
                </v-row>
            </v-container>
            <v-divider></v-divider>
            <v-container fluid>
                <v-row dense>
                    <v-col class="font-weight-bold">
                        初期チェック情報
                    </v-col>
                    <v-col class="text-right">
                        <v-btn
                            class="info"
                            @click="checkOpen()">更新
                        </v-btn>
                    </v-col>
                </v-row>
                <v-row dense>
                    <v-col cols="6" sm="3" lg="2">
                        <span class="font-weight-bold">M契約書</span><br>
                        {{checkToString(customer.chk_contract)}}
                    </v-col>
                    <v-col cols="6" sm="3" lg="2">
                        <span class="font-weight-bold">引落手続</span><br>
                        {{checkToString(customer.chk_direct_debit)}}
                    </v-col>
                    <v-col cols="6" sm="3" lg="2">
                        <span class="font-weight-bold">身分証明</span><br>
                        {{checkToString(customer.chk_identification)}}
                    </v-col>
                    <v-col cols="6" sm="3" lg="2">
                        <span class="font-weight-bold">独身証明</span><br>
                        {{checkToString(customer.chk_singlecert)}}
                    </v-col>
                    <v-col cols="6" sm="3" lg="2">
                        <span class="font-weight-bold">所得証明</span><br>
                        {{checkToString(customer.chk_income_cert)}}
                    </v-col>
                    <v-col cols="6" sm="3" lg="2">
                        <span class="font-weight-bold">最終学歴</span><br>
                        {{CUSTOMER.FINAL_EDUCATION.getName(customer.chk_fin_education)}}
                    </v-col>
                    <v-col cols="6" sm="3" lg="2">
                        <span class="font-weight-bold">卒業証明</span><br>
                        {{checkToString(customer.chk_graduation_cert)}}
                    </v-col>
                    <v-col cols="6" sm="3" lg="2">
                        <span class="font-weight-bold">M開通</span><br>
                        {{checkToString(customer.chk_opening)}}
                    </v-col>
                </v-row>
            </v-container>
            <v-divider></v-divider>
            <v-container fluid v-if="cs_customer!=null">
                <v-row dense>
                    <v-col class="font-weight-bold">
                        コネクトシップ用追加情報
                    </v-col>
                    <v-col class="text-right" v-if="!cs_customer.member_id">
                        <v-btn
                            class="error"
                            v-if="canProduction()"
                            @click="csSendProduction()">コネクトシップ送信
                        </v-btn>
                        <v-btn
                            class="info"
                            @click="csOpen()">編集
                        </v-btn>
                    </v-col>
                    <v-col class="text-right" v-else>
                        <v-btn
                            class="error"
                            @click="csJumpProduction()">コネクトシップを開く
                        </v-btn>
                    </v-col>
                </v-row>
                <v-row dense v-if="canTest()">
                    <v-col class="text-right" v-if="!cs_customer.member_id_test">
                        テスト環境
                        <v-btn
                            class="error"
                            @click="csSendTest()">コネクトシップ送信
                        </v-btn>
                    </v-col>
                    <v-col class="text-right" v-else>
                        テスト環境
                        <v-btn
                            class="error"
                            @click="csJumpTest()">コネクトシップを開く
                        </v-btn>
                    </v-col>
                </v-row>
                <v-row dense>
                    <v-col cols="6" sm="3" lg="2">
                        <span class="font-weight-bold">出生地</span><br>
                        {{getListName(csList.prefectures ,cs_customer.born_pref)}}
                    </v-col>
                    <v-col cols="6" sm="3" lg="2">
                        <span class="font-weight-bold">身長</span><br>
                        {{cs_customer.height}}cm
                    </v-col>
                    <v-col cols="6" sm="3" lg="2">
                        <span class="font-weight-bold">体重</span><br>
                        {{cs_customer.weight}}kg
                    </v-col>
                    <v-col cols="6" sm="3" lg="2">
                        <span class="font-weight-bold">結婚歴</span><br>
                        {{getListName(csList.marriage ,cs_customer.marriage)}}
                    </v-col>
                    <v-col cols="6" sm="3" lg="2">
                        <span class="font-weight-bold">子供の有無</span><br>
                        {{cs_customer.child?"有":"無"}}
                    </v-col>
                    <v-col cols="6" sm="3" lg="2">
                        <span class="font-weight-bold">勤務先</span><br>
                        {{cs_customer.office_name}}
                    </v-col>
                    <v-col cols="6" sm="3" lg="2">
                        <span class="font-weight-bold">勤務先名の紹介状への公開</span><br>
                        {{cs_customer.office_name_open?"公開":"非公開"}}
                    </v-col>
                    <v-col cols="6" sm="3" lg="2">
                        <span class="font-weight-bold">仕事内容</span><br>
                        {{cs_customer.job_name}}
                    </v-col>
                    <v-col cols="6" sm="3" lg="2">
                        <span class="font-weight-bold">年収</span><br>
                        {{getListName(csList.annual_income,cs_customer.annual_income)}}
                    </v-col>
                    <v-col cols="6" sm="3" lg="2">
                        <span class="font-weight-bold">最終学歴コード</span><br>
                        {{getListName(csList.academic,cs_customer.academic)}}
                    </v-col>
                    <v-col cols="6" sm="3" lg="2">
                        <span class="font-weight-bold">最終学校名</span><br>
                        {{cs_customer.ac_name}}
                    </v-col>
                    <v-col cols="6" sm="3" lg="2">
                        <span class="font-weight-bold">学校名の紹介状への公開</span><br>
                        {{cs_customer.ac_open?"公開":"非公開"}}
                    </v-col>
                    <v-col cols="6" sm="3" lg="2">
                        <span class="font-weight-bold">喫煙区分</span><br>
                        {{getListName(csList.smoke,cs_customer.smoke)}}
                    </v-col>
                    <v-col cols="6" sm="3" lg="2">
                        <span class="font-weight-bold">自己PR</span><br>
                        {{cs_customer.self_pr}}
                    </v-col>
                    <v-col cols="6" sm="3" lg="2">
                        <span class="font-weight-bold">続柄</span><br>
                        {{getListName(csList.relationship,cs_customer.relationship)}}
                    </v-col>
                    <v-col cols="6" sm="3" lg="2">
                        <span class="font-weight-bold">養子縁組</span><br>
                        {{getListName(csList.adoption,cs_customer.adoption)}}
                    </v-col>
                    <v-col cols="6" sm="3" lg="2">
                        <span class="font-weight-bold">親との同居</span><br>
                        {{getListName(csList.livewith_parent,cs_customer.livewith_parent)}}
                    </v-col>
                    <v-col cols="6" sm="3" lg="2">
                        <span class="font-weight-bold">所属区分</span><br>
                        {{getListName(csList.job_division,cs_customer.job_division)}}
                    </v-col>
                    <v-col cols="6" sm="3" lg="2">
                        <span class="font-weight-bold">雇用形態</span><br>
                        {{getListName(csList.emp_type,cs_customer.emp_type)}}
                    </v-col>
                    <v-col cols="6" sm="3" lg="2">
                        <span class="font-weight-bold">業種</span><br>
                        {{getListName(csList.ind_type,cs_customer.ind_type)}}
                    </v-col>
                    <v-col cols="6" sm="3" lg="2">
                        <span class="font-weight-bold">職業</span><br>
                        {{getListName(csList.occ_type,cs_customer.occ_type)}}
                    </v-col>
                    <v-col cols="6" sm="3" lg="2">
                        <span class="font-weight-bold">飲酒の習慣</span><br>
                        {{getListName(csList.drink,cs_customer.drink)}}
                    </v-col>
                    <v-col cols="6" sm="3" lg="2">
                        <span class="font-weight-bold">離婚回数</span><br>
                        {{cs_customer.divorce_times}}
                    </v-col>
                    <v-col cols="6" sm="3" lg="2">
                        <span class="font-weight-bold">離婚理由</span><br>
                        {{cs_customer.divorce_memo}}
                    </v-col>
                </v-row>
            </v-container>
            <v-container fluid v-else>
                <v-row dense>
                    <v-col class="font-weight-bold">
                        コネクトシップ用追加情報
                    </v-col>
                    <v-col class="text-right">
                        <v-btn
                            class="info"
                            @click="csOpen()">登録
                        </v-btn>
                    </v-col>
                </v-row>
            </v-container>
            <v-divider></v-divider>
            <v-container fluid v-if="canExit()">
                <v-row dense>
                    <v-col class="text-center" v-if="!customer.is_exit_reserve && !customer.is_exit">
                        <v-btn
                            @click="exitReserveOpen()"
                            dark
                            class="error"
                        >退会処理
                        </v-btn>
                    </v-col>
                    <v-col class="text-center" v-if="customer.is_exit_reserve && !customer.is_exit">
                        <v-btn
                            @click="cancelExitReserveOpen()"
                            dark
                            class="info"
                        >退会処理キャンセル
                        </v-btn>
                        <v-btn
                            @click="exitOpen()"
                            dark
                            class="error"
                        >退会確定
                        </v-btn>
                    </v-col>
                    <v-col v-if="canCancelExit" class="text-center">
                    <v-btn
                        dark
                        class="info"
                        @click="cancelExitOpen()"
                    >退会キャンセル
                    </v-btn>
                </v-col>
                </v-row>
            </v-container>

            <v-layout row justify-center>
                <v-dialog v-model="courseDialog" persistent max-width="600px">
                    <v-form>
                        <v-card>
                            <v-card-title>
                                <span class="headline" v-if="customer_course_all.length == 0">新規契約追加</span>
                                <span class="headline" v-else-if="!customer_course">契約追加</span>
                                <span class="headline" v-else>契約更新</span>
                            </v-card-title>
                            <v-card-text>
                                <v-container grid-list-md>
                                    <v-layout wrap>
                                        <v-flex xs6>
                                            <v-select
                                                v-model="courseData.course_id"
                                                :items="courses"
                                                label="コース"
                                                required
                                            ></v-select>
                                        </v-flex>
                                        <v-flex xs6>
                                            <v-menu
                                                :close-on-content-click="false"
                                                transition="scale-transition"
                                                offset-y
                                                max-width="290px"
                                                min-width="290px"
                                            >
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-text-field
                                                        v-model="courseData.contract_date"
                                                        label="契約日"
                                                        persistent-hint
                                                        v-bind="attrs"
                                                        @blur="crs_contract_date = parseDate(courseData.contract_date)"
                                                        v-on="on"
                                                        width="120px"
                                                        readonly
                                                    >
                                                    </v-text-field>
                                                </template>
                                                <v-date-picker
                                                    v-model="crs_contract_date"
                                                    :day-format="crs_contract_date => new Date(crs_contract_date).getDate()"
                                                    no-title
                                                ></v-date-picker>
                                            </v-menu>
                                        </v-flex>
                                    </v-layout>
                                </v-container>
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                    class="info"
                                    :disabled="!courseData.course_id || !courseData.contract_date"
                                    @click="courseContract"
                                    v-if="customer_course_all.length == 0"
                                >新規契約追加
                                </v-btn>
                                <v-btn
                                    class="info"
                                    :disabled="!courseData.course_id || !courseData.contract_date"
                                    @click="moveToCourseRule"
                                    v-else-if="!customer_course"
                                >契約追加
                                </v-btn>
                                <v-btn
                                    class="info"
                                    :disabled="!courseData.course_id || !courseData.contract_date"
                                    @click="moveToCourseRule"
                                    v-else
                                >契約更新
                                </v-btn>
                                <v-btn @click="courseClose">キャンセル</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-form>
                </v-dialog>
            </v-layout>
            <v-layout row justify-center>
                <v-dialog v-model="checkDialog" persistent max-width="600px">
                    <v-form>
                        <v-card>
                            <v-card-title>
                                <span class="headline">初期チェック情報</span>
                            </v-card-title>
                            <v-card-text>
                                <v-container grid-list-md>
                                    <v-layout wrap>
                                        <v-flex xs6>
                                            <v-select
                                                v-model="checkData.contract"
                                                :items="checkList"
                                                label="M契約書"
                                                required
                                            ></v-select>
                                        </v-flex>
                                        <v-flex xs6>
                                            <v-menu
                                                :close-on-content-click="false"
                                                transition="scale-transition"
                                                offset-y
                                                max-width="290px"
                                                min-width="290px"
                                            >
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-text-field
                                                        v-model="checkData.contract_date"
                                                        label="M契約書-日時"
                                                        persistent-hint
                                                        v-bind="attrs"
                                                        @blur="chk_contract_date = parseDate(checkData.contract_date)"
                                                        v-on="on"
                                                        width="120px"
                                                    >
                                                    </v-text-field>
                                                </template>
                                                <v-date-picker
                                                    v-model="chk_contract_date"
                                                    :day-format="chk_contract_date => new Date(chk_contract_date).getDate()"
                                                    no-title
                                                ></v-date-picker>
                                            </v-menu>
                                        </v-flex>
                                        <v-flex xs6>
                                            <v-select
                                                v-model="checkData.direct_debit"
                                                :items="checkList"
                                                label="引落手続"
                                                required
                                            ></v-select>
                                        </v-flex>
                                        <v-flex xs6>
                                            <v-menu
                                                :close-on-content-click="false"
                                                transition="scale-transition"
                                                offset-y
                                                max-width="290px"
                                                min-width="290px"
                                            >
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-text-field
                                                        v-model="checkData.direct_debit_date"
                                                        label="引落手続-日時"
                                                        persistent-hint
                                                        v-bind="attrs"
                                                        @blur="chk_direct_debit_date = parseDate(checkData.direct_debit_date)"
                                                        v-on="on"
                                                        width="120px"
                                                    >
                                                    </v-text-field>
                                                </template>
                                                <v-date-picker
                                                    v-model="chk_direct_debit_date"
                                                    :day-format="chk_direct_debit_date => new Date(chk_direct_debit_date).getDate()"
                                                    no-title
                                                ></v-date-picker>
                                            </v-menu>
                                        </v-flex>
                                        <v-flex xs6>
                                            <v-select
                                                v-model="checkData.identification"
                                                :items="checkList"
                                                label="身分証明"
                                                required
                                            ></v-select>
                                        </v-flex>
                                        <v-flex xs6>
                                            <v-menu
                                                :close-on-content-click="false"
                                                transition="scale-transition"
                                                offset-y
                                                max-width="290px"
                                                min-width="290px"
                                            >
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-text-field
                                                        v-model="checkData.identification_date"
                                                        label="身分証明-日時"
                                                        persistent-hint
                                                        v-bind="attrs"
                                                        @blur="chk_identification_date = parseDate(checkData.identification_date)"
                                                        v-on="on"
                                                        width="120px"
                                                    >
                                                    </v-text-field>
                                                </template>
                                                <v-date-picker
                                                    v-model="chk_identification_date"
                                                    :day-format="chk_identification_date => new Date(chk_identification_date).getDate()"
                                                    no-title
                                                ></v-date-picker>
                                            </v-menu>
                                        </v-flex>
                                        <v-flex xs6>
                                            <v-select
                                                v-model="checkData.singlecert"
                                                :items="checkList"
                                                label="独身証明"
                                                required
                                            ></v-select>
                                        </v-flex>
                                        <v-flex xs6>
                                            <v-menu
                                                :close-on-content-click="false"
                                                transition="scale-transition"
                                                offset-y
                                                max-width="290px"
                                                min-width="290px"
                                            >
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-text-field
                                                        v-model="checkData.singlecert_date"
                                                        label="独身証明-日時"
                                                        persistent-hint
                                                        v-bind="attrs"
                                                        @blur="chk_singlecert_date = parseDate(checkData.singlecert_date)"
                                                        v-on="on"
                                                        width="120px"
                                                    >
                                                    </v-text-field>
                                                </template>
                                                <v-date-picker
                                                    v-model="chk_singlecert_date"
                                                    :day-format="chk_singlecert_date => new Date(chk_singlecert_date).getDate()"
                                                    no-title
                                                ></v-date-picker>
                                            </v-menu>
                                        </v-flex>
                                        <v-flex xs6>
                                            <v-select
                                                v-model="checkData.income_cert"
                                                :items="checkList"
                                                label="所得証明"
                                                required
                                            ></v-select>
                                        </v-flex>
                                        <v-flex xs6>
                                            <v-menu
                                                :close-on-content-click="false"
                                                transition="scale-transition"
                                                offset-y
                                                max-width="290px"
                                                min-width="290px"
                                            >
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-text-field
                                                        v-model="checkData.income_cert_date"
                                                        label="所得証明-日時"
                                                        persistent-hint
                                                        v-bind="attrs"
                                                        @blur="chk_income_cert_date = parseDate(checkData.income_cert_date)"
                                                        v-on="on"
                                                        width="120px"
                                                    >
                                                    </v-text-field>
                                                </template>
                                                <v-date-picker
                                                    v-model="chk_income_cert_date"
                                                    :day-format="chk_income_cert_date => new Date(chk_income_cert_date).getDate()"
                                                    no-title
                                                ></v-date-picker>
                                            </v-menu>
                                        </v-flex>
                                        <v-flex xs6>
                                            <v-select
                                                v-model="checkData.chk_fin_education"
                                                :items="CUSTOMER.FINAL_EDUCATION.LIST"
                                                label="最終学歴"
                                                required
                                            ></v-select>
                                        </v-flex>
                                        <v-flex xs6>
                                        </v-flex>
                                        <v-flex xs6>
                                            <v-select
                                                v-model="checkData.graduation_cert"
                                                :items="checkList"
                                                label="卒業証明"
                                                required
                                            ></v-select>
                                        </v-flex>
                                        <v-flex xs6>
                                            <v-menu
                                                :close-on-content-click="false"
                                                transition="scale-transition"
                                                offset-y
                                                max-width="290px"
                                                min-width="290px"
                                            >
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-text-field
                                                        v-model="checkData.graduation_cert_date"
                                                        label="卒業証明-日時"
                                                        persistent-hint
                                                        v-bind="attrs"
                                                        @blur="chk_graduation_cert_date = parseDate(checkData.graduation_cert_date)"
                                                        v-on="on"
                                                        width="120px"
                                                    >
                                                    </v-text-field>
                                                </template>
                                                <v-date-picker
                                                    v-model="chk_graduation_cert_date"
                                                    :day-format="chk_graduation_cert_date => new Date(chk_graduation_cert_date).getDate()"
                                                    no-title
                                                ></v-date-picker>
                                            </v-menu>
                                        </v-flex>
                                        <v-flex xs6>
                                            <v-select
                                                v-model="checkData.opening"
                                                :items="checkList"
                                                label="M開通"
                                                required
                                            ></v-select>
                                        </v-flex>
                                        <v-flex xs6>
                                            <v-menu
                                                :close-on-content-click="false"
                                                transition="scale-transition"
                                                offset-y
                                                max-width="290px"
                                                min-width="290px"
                                            >
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-text-field
                                                        v-model="checkData.opening_date"
                                                        label="M開通-日時"
                                                        persistent-hint
                                                        v-bind="attrs"
                                                        @blur="chk_opening_date = parseDate(checkData.opening_date)"
                                                        v-on="on"
                                                        width="120px"
                                                    >
                                                    </v-text-field>
                                                </template>
                                                <v-date-picker
                                                    v-model="chk_opening_date"
                                                    :day-format="chk_opening_date => new Date(chk_opening_date).getDate()"
                                                    no-title
                                                ></v-date-picker>
                                            </v-menu>
                                        </v-flex>
                                    </v-layout>
                                </v-container>
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                    class="info"
                                    @click="checkSave"
                                >保存
                                </v-btn>
                                <v-btn @click="checkClose">キャンセル</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-form>
                </v-dialog>
            </v-layout>
            <v-layout row justify-center>
                <v-dialog v-model="csDialog" persistent max-width="1200px">
                    <v-form v-model="csValid">
                        <v-card>
                            <v-card-title>
                                <span class="headline" v-if="!cs_customer">コネクトシップ用追加情報追加</span>
                                <span class="headline" v-else>コネクトシップ用追加情報変更</span>
                            </v-card-title>
                            <v-card-text>
                                <v-container grid-list-md>
                                    <v-layout wrap>
                                        <v-flex xs2>
                                            <v-select
                                                v-model="csData.born_pref"
                                                :items="csList.prefectures"
                                                label="出生地"
                                                required
                                            ></v-select>
                                        </v-flex>
                                        <v-flex xs2>
                                            <v-text-field
                                                v-model.number="csData.height"
                                                type="number"
                                                label="身長"
                                                required
                                            ></v-text-field>
                                        </v-flex>
                                        <v-flex xs2>
                                            <v-text-field
                                                v-model.number="csData.weight"
                                                type="number"
                                                label="体重"
                                                required
                                            ></v-text-field>
                                        </v-flex>
                                        <v-flex xs2>
                                            <v-select
                                                v-model="csData.marriage"
                                                :items="csList.marriage"
                                                label="結婚歴"
                                                required
                                            ></v-select>
                                        </v-flex>
                                        <v-flex xs2>
                                            <v-checkbox
                                                label="子供あり"
                                                v-model="csData.child"
                                            ></v-checkbox>
                                        </v-flex>
                                        <v-flex xs2>
                                            <v-text-field
                                                v-model="csData.office_name"
                                                label="勤務先"
                                                required
                                            ></v-text-field>
                                        </v-flex>
                                        <v-flex xs2>
                                            <v-checkbox
                                                label="勤務先名の紹介状への公開可"
                                                v-model="csData.office_name_open"
                                            ></v-checkbox>
                                        </v-flex>
                                        <v-flex xs2>
                                            <v-text-field
                                                v-model="csData.job_name"
                                                label="仕事内容"
                                                required
                                            ></v-text-field>
                                        </v-flex>
                                        <v-flex xs2>
                                            <v-select
                                                v-model="csData.annual_income"
                                                :items="csList.annual_income"
                                                label="年収"
                                                required
                                            ></v-select>
                                        </v-flex>
                                        <v-flex xs2>
                                            <v-select
                                                v-model="csData.academic"
                                                :items="csList.academic"
                                                label="最終学歴コード"
                                                required
                                            ></v-select>
                                        </v-flex>
                                        <v-flex xs2>
                                            <v-text-field
                                                v-model="csData.ac_name"
                                                label="最終学校名"
                                                required
                                            ></v-text-field>
                                        </v-flex>
                                        <v-flex xs2>
                                            <v-checkbox
                                                label="学校名の紹介状への公開可"
                                                v-model="csData.ac_open"
                                            ></v-checkbox>
                                        </v-flex>
                                        <v-flex xs2>
                                            <v-checkbox
                                                label="喫煙区分"
                                                v-model="csData.smoke"
                                            ></v-checkbox>
                                        </v-flex>
                                        <v-flex xs2>
                                            <v-text-field
                                                v-model="csData.self_pr"
                                                label="自己PR"
                                                required
                                            ></v-text-field>
                                        </v-flex>
                                        <v-flex xs2>
                                            <v-select
                                                v-model="csData.relationship"
                                                :items="csList.relationship"
                                                label="続柄"
                                                required
                                            ></v-select>
                                        </v-flex>
                                        <v-flex xs2>
                                            <v-select
                                                v-model="csData.adoption"
                                                :items="csList.adoption"
                                                label="養子縁組"
                                                required
                                            ></v-select>
                                        </v-flex>
                                        <v-flex xs2>
                                            <v-select
                                                v-model="csData.livewith_parent"
                                                :items="csList.livewith_parent"
                                                label="親との同居"
                                                required
                                            ></v-select>
                                        </v-flex>
                                        <v-flex xs2>
                                            <v-select
                                                v-model="csData.job_division"
                                                :items="csList.job_division"
                                                label="所属区分"
                                                required
                                            ></v-select>
                                        </v-flex>
                                        <v-flex xs2>
                                            <v-select
                                                v-model="csData.emp_type"
                                                :items="csList.emp_type"
                                                label="雇用形態"
                                                required
                                            ></v-select>
                                        </v-flex>
                                        <v-flex xs2>
                                            <v-select
                                                v-model="csData.ind_type"
                                                :items="csList.ind_type"
                                                label="業種"
                                                required
                                            ></v-select>
                                        </v-flex>
                                        <v-flex xs2>
                                            <v-select
                                                v-model="csData.occ_type"
                                                :items="csList.occ_type"
                                                label="職業"
                                                required
                                            ></v-select>
                                        </v-flex>
                                        <v-flex xs2>
                                            <v-select
                                                v-model="csData.drink"
                                                :items="csList.drink"
                                                label="飲酒の習慣"
                                                required
                                            ></v-select>
                                        </v-flex>
                                        <v-flex xs2>
                                            <v-text-field
                                                v-model.number="csData.divorce_times"
                                                type="number"
                                                label="離婚回数"
                                                required
                                            ></v-text-field>
                                        </v-flex>
                                        <v-flex xs2>
                                            <v-text-field
                                                v-model="csData.divorce_memo"
                                                label="離婚理由"
                                                required
                                            ></v-text-field>
                                        </v-flex>
                                    </v-layout>
                                </v-container>
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                    class="info"
                                    @click="csSave"
                                    :disabled="!csValid"
                                >保存
                                </v-btn>
                                <v-btn @click="csClose">キャンセル</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-form>
                </v-dialog>
            </v-layout>
            
            <v-layout row justify-center>
                <v-dialog v-model="exitReserveDialog" persistent max-width="480px">
                    <v-card>
                        <v-card-title>退会処理</v-card-title>
                        <v-card-text>
                            コネクトシップ使用中の場合は、コネクトシップ会員の退会処理を行ってください。<br>
                            退会処理を行ってよろしいですか？
                            <v-container grid-list-md>
                                <v-layout wrap>
                                    <v-flex xs6>
                                        <v-select
                                            v-model="exitReason"
                                            :items="CUSTOMER.EXIT_REASON.LIST"
                                            label="退会理由"
                                        ></v-select>
                                    </v-flex>
                                    <v-flex xs6>
                                        <v-menu
                                            :close-on-content-click="false"
                                            transition="scale-transition"
                                            offset-y
                                            max-width="290px"
                                            min-width="290px"
                                        >
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-text-field
                                                    v-model="exitDate"
                                                    label="退会日"
                                                    persistent-hint
                                                    v-bind="attrs"
                                                    @blur="exit_date = parseDate(exitDate)"
                                                    v-on="on"
                                                    width="120px"
                                                >
                                                </v-text-field>
                                            </template>
                                            <v-date-picker
                                                v-model="exit_date"
                                                :day-format="exit_date => new Date(exit_date).getDate()"
                                                no-title
                                            ></v-date-picker>
                                        </v-menu>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn :dark="exitReason!=0&&exitDate!=null" class="delete" @click="exitReserveExec" :disabled="exitReason==0 || exitDate==null"
                                >OK</v-btn
                            >
                            <v-btn @click="exitReserveClose">キャンセル</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-layout>
            <v-layout row justify-center>
                <v-dialog v-model="cancelExitReserveDialog" persistent max-width="480px">
                    <v-card>
                        <v-card-title>退会処理キャンセル</v-card-title>
                        <v-card-text>退会処理をキャンセルしますか？</v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn dark class="info" @click="cancelExitReserveExec"
                                >OK</v-btn
                            >
                            <v-btn @click="cancelExitReserveClose">キャンセル</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-layout>
            <v-layout row justify-center>
                <v-dialog v-model="exitDialog" persistent max-width="480px">
                    <v-card>
                        <v-card-title>退会確定</v-card-title>
                        <v-card-subtitle class="error--text">{{CUSTOMER.EXIT_REASON.getName(customer.exit_reason)}}</v-card-subtitle>
                        <v-card-text>
                            コネクトシップ使用中の場合は、コネクトシップ会員の退会処理を行ってください。<br>
                            退会を確定してもよろしいですか？
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn dark class="error" @click="exitExec"
                                >OK</v-btn
                            >
                            <v-btn @click="exitClose">キャンセル</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-layout>
            <v-layout row justify-center>
                <v-dialog v-model="deleteCourseDialog" persistent max-width="345px">
                    <v-card>
                        <v-card-title>削除してよろしいですか？</v-card-title>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn dark class="error" @click="deleteContract"
                                >削除</v-btn
                            >
                            <v-btn @click="closeDialogDeleteCourse">キャンセル</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-layout>
        </v-card-text>
        <v-dialog v-model="isConfirmingCancelExit" max-width="480px">
            <v-card>
                <v-card-title>退会キャンセル</v-card-title>
                <v-card-text>退会をキャンセルしますか？</v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn dark class="info" @click="cancelExitExec"
                        >OK</v-btn
                    >
                    <v-btn @click="cancelExitClose">キャンセル</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-card>
</template>
        
<script>
import ACCOUNT from "@/consts/account.js";
import CUSTOMER from "@/consts/customer.js";
import utilDatetime from "@/utilities/datetime.js"
import moment from "moment"
import { mapState } from "vuex";

export default {
    title() {
        return `${this.customer.family_name} ${this.customer.given_name} (カルテ)`;
    },
    name: 'customer_detail',
    mixins: [utilDatetime],
    data: () => ({
        CUSTOMER: CUSTOMER,
        courses: [],
        customer: {
            shop_id: null,
            counselor_id: null,
            front_id: null,
            front_name: "",
            number: "",
            valid_mail: false,
            family_name: "",
            given_name: "",
            family_name_kana: "",
            given_name_kana: "",
            gender: 1,
            blood_type: 1,
            birthday: "",
            phone_number: "",
            phone_number_home: "",
            tel_enable_date: "",
            tel_enable_time: "",
            holidays: "",
            company_name: "",
            company_name_kana: "",
            company_zip: "",
            company_address: "",
            company_tel: "",
            industry: "",
            employment_years: "",
            income: "",
            email_address: "",
            zip: "",
            pref: 0,
            address1: "",
            address2: "",
            building_name: "",
            is_exit_reserve: false,
            is_exit: false,
            exit_reason: 0,
            line_link: "",
            connect_federation: false,
            ibj_federation: false,
        },
        cs_customer: null,
        courseHeaders: [
            { text: "コース名", value: "course_id", align: "start", sortable: false },
            { text: "契約日", value: "contract_date", align: "start", sortable: false },
            { text: "契約最終日", value: "end_date", align: "start", sortable: false },
            { text: "", value: "action", align: "start", sortable: false },
        ],
        customer_course: null,
        customer_course_all: [],
        courseData: {
            customer_id: null,
            course_id: null,
            contract_date: null,
        },
        courseDialog: false,
        checkData: {
            contract: null,
            contract_date: null,
            direct_debit: null,
            direct_debit_date: null,
            identification: null,
            identification_date: null,
            singlecert: null,
            singlecert_date: null,
            income_cert: null,
            income_cert_date: null,
            fin_education: null,
            fin_education_date: null,
            graduation_cert: null,
            graduation_cert_date: null,
            opening: null,
            opening_date: null,
        },
        crs_contract_date: null,
        chk_contract_date: null,
        chk_direct_debit_date: null,
        chk_identification_date: null,
        chk_singlecert_date: null,
        chk_income_cert_date: null,
        chk_graduation_cert_date: null,
        chk_opening_date: null,
        checkDialog: false,
        checkList: [
            { text: "未", value: 0 },
            { text: "済", value: 1 },
            { text: "無", value: 2 },
        ],
        csData: {
        },
        csValid: false,
        csDialog: false,
        csList: {
            prefectures: [
                { text: "北海道", value: 1 },
                { text: "青森県", value: 2 },
                { text: "岩手県", value: 3 },
                { text: "宮城県", value: 4 },
                { text: "秋田県", value: 5 },
                { text: "山形県", value: 6 },
                { text: "福島県", value: 7 },
                { text: "茨城県", value: 8 },
                { text: "栃木県", value: 9 },
                { text: "群馬県", value: 10 },
                { text: "埼玉県", value: 11 },
                { text: "千葉県", value: 12 },
                { text: "東京都", value: 13 },
                { text: "神奈川県", value: 14 },
                { text: "新潟県", value: 15 },
                { text: "富山県", value: 16 },
                { text: "石川県", value: 17 },
                { text: "福井県", value: 18 },
                { text: "山梨県", value: 19 },
                { text: "長野県", value: 20 },
                { text: "岐阜県", value: 21 },
                { text: "静岡県", value: 22 },
                { text: "愛知県", value: 23 },
                { text: "三重県", value: 24 },
                { text: "滋賀県", value: 25 },
                { text: "京都府", value: 26 },
                { text: "大阪府", value: 27 },
                { text: "兵庫県", value: 28 },
                { text: "奈良県", value: 29 },
                { text: "和歌山県", value: 30 },
                { text: "鳥取県", value: 31 },
                { text: "島根県", value: 32 },
                { text: "岡山県", value: 33 },
                { text: "広島県", value: 34 },
                { text: "山口県", value: 35 },
                { text: "徳島県", value: 36 },
                { text: "香川県", value: 37 },
                { text: "愛媛県", value: 38 },
                { text: "高知県", value: 39 },
                { text: "福岡県", value: 40 },
                { text: "佐賀県", value: 41 },
                { text: "長崎県", value: 42 },
                { text: "熊本県", value: 43 },
                { text: "大分県", value: 44 },
                { text: "宮崎県", value: 45 },
                { text: "鹿児島県", value: 46 },
                { text: "沖縄県", value: 47 },
                { text: "海外", value: 99 },
            ],
            marriage: [
            { text: "未婚", value: 0 },
            { text: "離婚", value: 1 },
            { text: "死別", value: 2 },
            ],
            annual_income: [
                { text: "0-50万円", value: 0 },
                { text: "50-100万円", value: 50 },
                { text: "100-150万円", value: 100 },
                { text: "150-200万円", value: 150 },
                { text: "200-250万円", value: 200 },
                { text: "250-300万円", value: 250 },
                { text: "300-350万円", value: 300 },
                { text: "350-400万円", value: 350 },
                { text: "400-450万円", value: 400 },
                { text: "450-500万円", value: 450 },
                { text: "500-550万円", value: 500 },
                { text: "550-600万円", value: 550 },
                { text: "600-650万円", value: 600 },
                { text: "650-700万円", value: 650 },
                { text: "700-750万円", value: 700 },
                { text: "750-800万円", value: 750 },
                { text: "800-850万円", value: 800 },
                { text: "850-900万円", value: 850 },
                { text: "900-950万円", value: 900 },
                { text: "950-1000万円", value: 950 },
                { text: "1000-1100万円", value: 1000 },
                { text: "1100-1200万円", value: 1100 },
                { text: "1200-1300万円", value: 1200 },
                { text: "1300-1400万円", value: 1300 },
                { text: "1400-1500万円", value: 1400 },
                { text: "1500-1600万円", value: 1500 },
                { text: "1600-1700万円", value: 1600 },
                { text: "1700-1800万円", value: 1700 },
                { text: "1800-1900万円", value: 1800 },
                { text: "1900-2000万円", value: 1900 },
                { text: "2000-2100万円", value: 2000 },
                { text: "2100-2200万円", value: 2100 },
                { text: "2200-2300万円", value: 2200 },
                { text: "2300-2400万円", value: 2300 },
                { text: "2400-2500万円", value: 2400 },
                { text: "2500-2600万円", value: 2500 },
                { text: "2600-2700万円", value: 2600 },
                { text: "2700-2800万円", value: 2700 },
                { text: "2800-2900万円", value: 2800 },
                { text: "2900-3000万円", value: 2900 },
                { text: "3000万円以上", value: 3000 },
            ],
            academic: [
                { text: "中学卒業", value: 13 },
                { text: "高校中退", value: 31 },
                { text: "高校卒業", value: 33 },
                { text: "専門学校・各種学校中退", value: 41 },
                { text: "専門学校・各種学校在学", value: 42 },
                { text: "専門学校・各種学校卒業", value: 43 },
                { text: "高専中退", value: 51 },
                { text: "高専在学", value: 52 },
                { text: "高専卒業", value: 53 },
                { text: "短大中退", value: 71 },
                { text: "短大在学", value: 72 },
                { text: "短大卒業", value: 73 },
                { text: "大学中退", value: 81 },
                { text: "大学在学", value: 82 },
                { text: "大学卒業", value: 83 },
                { text: "大学院中退", value: 91 },
                { text: "大学院在学", value: 92 },
                { text: "大学院修了", value: 93 },
            ],
            smoke: [
                { text: "すわない", value: 0 },
                { text: "時々すう", value: 1 },
                { text: "すう", value: 2 },
            ],
            relationship: [
				{ text: "長男", value: 1 },
				{ text: "次男", value: 2 },
				{ text: "三男", value: 3 },
				{ text: "四男", value: 4 },
				{ text: "五男", value: 5 },
				{ text: "六男", value: 6 },
				{ text: "七男", value: 7 },
				{ text: "八男", value: 8 },
				{ text: "九男", value: 9 },
				{ text: "十男", value: 10 },
				{ text: "長女", value: 21 },
				{ text: "次女", value: 22 },
				{ text: "三女", value: 23 },
				{ text: "四女", value: 24 },
				{ text: "五女", value: 25 },
				{ text: "六女", value: 26 },
				{ text: "七女", value: 27 },
				{ text: "八女", value: 28 },
				{ text: "九女", value: 29 },
				{ text: "十女", value: 30 },
            ],
            adoption: [
                { text: "こだわらない(男)", value: 10 },
                { text: "相談のうえ(男)", value: 11 },
                { text: "養子NG(男)", value: 12 },
                { text: "こだわらない(女)", value: 20 },
                { text: "相談のうえ(女)", value: 21 },
                { text: "養子が条件(女)", value: 22 },
            ],
            livewith_parent: [
                { text: "必要なし", value: 0 },
                { text: "必要", value: 1 },
                { text: "お相手と相談", value: 2 },
            ],
            job_division: [
                { text: "個人事業主", value: 1 },
                { text: "民間企業・一般営利法人", value: 2 },
                { text: "官公署（国家公務員）", value: 3 },
                { text: "官公署（地方公務員）", value: 4 },
                { text: "その他法人・組合", value: 5 },
                { text: "無職（家事手伝い・学生含む）", value: 6 },
                { text: "その他", value: 9 },
            ],
            ind_type: [
                { text: "水産・農林業", value: 1 },
				{ text: "鉱業", value: 2 },
				{ text: "建設業", value: 3 },
				{ text: "食料品", value: 4 },
				{ text: "繊維製品", value: 5 },
				{ text: "パルプ・紙", value: 6 },
				{ text: "化学", value: 7 },
				{ text: "医薬品", value: 8 },
				{ text: "石油・石炭製品", value: 9 },
				{ text: "ゴム製品", value: 10 },
				{ text: "ガラス・土石製品", value: 11 },
				{ text: "鉄鋼", value: 12 },
				{ text: "非鉄金属", value: 13 },
				{ text: "機械", value: 14 },
				{ text: "電気機器", value: 15 },
				{ text: "輸送用機器", value: 16 },
				{ text: "精密機器", value: 17 },
				{ text: "その他製品", value: 18 },
				{ text: "電気・ガス業", value: 19 },
				{ text: "陸運業", value: 20 },
				{ text: "海運業", value: 21 },
				{ text: "空運業", value: 22 },
				{ text: "倉庫業", value: 23 },
				{ text: "情報通信業", value: 24 },
				{ text: "卸売業", value: 25 },
				{ text: "小売業", value: 26 },
				{ text: "銀行業", value: 27 },
				{ text: "証券、商品先物取り引き業", value: 28 },
				{ text: "保険業", value: 29 },
				{ text: "その他金融業", value: 30 },
				{ text: "不動産業", value: 31 },
				{ text: "サービス業", value: 32 },
				{ text: "士業・他", value: 33 },
				{ text: "飲食店・宿泊業", value: 36 },
				{ text: "教育・学習支援業", value: 37 },
				{ text: "医療・福祉業", value: 34 },
				{ text: "その他", value: 99 },
            ],
            emp_type: [
                { text: "経営者", value: 1 },
                { text: "正社員", value: 2 },
                { text: "契約社員", value: 3 },
                { text: "派遣社員", value: 4 },
                { text: "パート社員", value: 5 },
                { text: "アルバイト", value: 6 },
                { text: "その他", value: 9 },
            ],
            occ_type: [
				{ text: "専門職", value: 1 },
				{ text: "管理職", value: 2 },
				{ text: "事務職", value: 3 },
				{ text: "営業・販売職", value: 4 },
				{ text: "サービス職", value: 5 },
				{ text: "農林魚業職", value: 7 },
				{ text: "運輸通信職", value: 8 },
				{ text: "生産労務職・労務・保安職", value: 9 },
				{ text: "その他", value: 99 },
            ],
            drink: [
				{ text: "飲まない", value: 0 },
				{ text: "付き合い程度", value: 1 },
				{ text: "飲む（たしなむ）", value: 2 },
            ],
        },
        exitReason: 0,
        exit_date: null,
        exitDate: null,
        exitReserveDialog: false,
        cancelExitReserveDialog: false,
        exitDialog: false,
        showContractRuleDialog: false,
        deleteCourseDialog: false,
        idCourseCanDelete: null,
        isConfirmingCancelExit: false,
        claimFiles: []
    }),
    watch: {
        crs_contract_date() {
            this.courseData.contract_date = this.formatDate(this.crs_contract_date);
        },
        chk_contract_date () {
            this.checkData.contract_date = this.formatDate(this.chk_contract_date);
        },
        chk_direct_debit_date () {
            this.checkData.direct_debit_date = this.formatDate(this.chk_direct_debit_date);
        },
        chk_identification_date () {
            this.checkData.identification_date = this.formatDate(this.chk_identification_date);
        },
        chk_singlecert_date () {
            this.checkData.singlecert_date = this.formatDate(this.chk_singlecert_date);
        },
        chk_income_cert_date () {
            this.checkData.income_cert_date = this.formatDate(this.chk_income_cert_date);
        },
        chk_graduation_cert_date () {
            this.checkData.graduation_cert_date = this.formatDate(this.chk_graduation_cert_date);
        },
        chk_opening_date () {
            this.checkData.opening_date = this.formatDate(this.chk_opening_date);
        },
        exit_date () {
            this.exitDate = this.formatDate(this.exit_date)
        },
    },
    computed: {
        ...mapState(['user']),
        canCancelExit() {
            return this.customer.is_exit && (this.user.privilege & ACCOUNT.PRIVILEGE.VAL.CUSTOMER_EXIT);
        }
    },
    async mounted() {
        await this.loadInit();
    },
    methods: {
        cancelExitOpen() {
            this.isConfirmingCancelExit = true;
        },
        cancelExitClose() {
            this.isConfirmingCancelExit = false;
        },
        async cancelExitExec() {
            if (this.canCancelExit) {
                try {
                    await this.$axios.post(`/api/v1/customer/cancel_exit/${this.customer.id}`)
                    this.customer.is_exit = false;
                    this.customer.is_exit_reserve = false;
                    this.customer.exit_reason = 0;
                    this.customer.exit_date = null;
                } catch (error) {
                    console.log("Error : " + error);
                } finally {
                    this.isConfirmingCancelExit = false;
                }
            } else {
                this.isConfirmingCancelExit = false;
            }
        },
        async loadInit() {
            this.getClaimFiles();
            const id = this.$route.params.id;
            const result = await this.$axios
                .get(`/api/v1/customer/${id}`)
                .then((response) => {
                    return response.data;
                })
                .catch((error) => {
                    return error;
                });

            if (result) {
                this.customer = result.customer;
                this.customer_course = result.course;
                this.courses = result.courses;
                this.cs_customer = result.cs_customer;

                this.setTitle();
            }

            const existingCourseContracts = await this.$axios
                .get(`/api/v1/course-contract/customer/${id}/existing-items`)
                .then((response) => {
                    return response.data;
                })
                .catch((error) => {
                    return error;
                });
            if (existingCourseContracts) {
                this.customer_course_all = existingCourseContracts.courses;
            }
        },
        async getClaimFiles () {
          const id = this.$route.params.id;
          const claimFiles = await this.$axios.get(`/api/v1/customer/${id}/claim-files`);
          this.claimFiles = claimFiles.data;
        },
        getCourseName(id) {
            if(!this.courses) return "";
            const course = this.courses.find( (c) => {
                return c.value == id;
            });
            if(!course) return "";
            return course.text;
        },
        checkToString(check) {
            if(!check) return "";
            switch(check.state) {
            case 0: return "未";
            case 1:
                {
                const date = new Date(check.date);
                return `済(${date.toLocaleDateString()})`;
                }
            case 2: return "無";
            }
        },
        async courseContract(){
            this.courseData.customer_id = this.customer.id;
            await this.$axios
                .post(`/api/v1/customer_course/contract/`, this.courseData)
                .then((response) => {
                    this.customer.contract_date = response.data.contract_date;
                    this.customer.year = response.data.year;
                    this.customer_course = response.data.customer_course;
                    this.customer_course_all = response.data.customer_course_all;
                })
                .catch((error) => {
                    console.log("Error : " + error);
                });
            const existingCourseContracts = await this.$axios
                .get(`/api/v1/course-contract/customer/${this.courseData.customer_id}/existing-items`)
                .then((response) => {
                    return response.data;
                })
                .catch((error) => {
                    return error;
                });
            if (existingCourseContracts) {
                this.customer_course_all = existingCourseContracts.courses;
            }    
            this.courseClose();
        },
        async courseAdd(){
            this.courseData.customer_id = this.customer.id;
            await this.$axios
                .post(`/api/v1/customer_course/add/`, this.courseData)
                .then((response) => {
                    this.customer.contract_date = response.data.contract_date;
                    this.customer.year = response.data.year;
                    this.customer_course = response.data.customer_course;
                    this.customer_course_all = response.data.customer_course_all;
                })
                .catch((error) => {
                    console.log("Error : " + error);
                });
            const existingCourseContracts = await this.$axios
                .get(`/api/v1/course-contract/customer/${this.courseData.customer_id}/existing-items`)
                .then((response) => {
                    return response.data;
                })
                .catch((error) => {
                    return error;
                });
            if (existingCourseContracts) {
                this.customer_course_all = existingCourseContracts.courses;
            }
            this.courseClose();
        },
        async moveToCourseRule() {
            if (this.customer.is_exit || this.customer.is_exit_reserve) {
                this.courseUpdate();
                return;
            }

            const check = [...this.customer_course_all].reverse().find(c => c.course_id === 1 || c.course_id === 2 || c.course_id === 3 || c.course_id === 4);
            const isSpecialCourse = this.courseData.course_id === 1 || this.courseData.course_id === 2 || this.courseData.course_id === 3 || this.courseData.course_id === 4;
            if (isSpecialCourse && check) {
                const start_date = await this.calculateStartDate(check);
                this.$store.dispatch('updateContractDate', this.courseData.contract_date);
                this.$store.dispatch('updateContractStartDate', start_date);
                this.$router.push({
                    name: 'customer_contract_rules',
                    params: {
                        courseId: this.courseData.course_id,
                        userId: this.customer.id,
                    }
                });
            } else {
                this.courseUpdate();
            }
        },
        async calculateStartDate(course) {
            try {
                const res = await this.$axios.get(`/api/v1/course-contract/is-exist/${course.id}`);
                const course_data = res.data.course_data
                return course_data.end_date ? this.addOneDayAndFormat(course_data.end_date) : this.addOneDayAndFormat(course_data.contract_date);
            } catch (error) {
                console.log("Error : " + error)
            }
        },
        addOneDayAndFormat(enddate) {
            const date = new Date(enddate);
            date.setDate(date.getDate() + 1);
            
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            
            return `${year}/${month}/${day}`;
        },
        async navigateToDetail(item) {
            try {
                const res = await this.$axios.get(`/api/v1/course-contract/is-exist/${item.id}`);
                if (res.data.isExist) {
                    const url = this.$router.resolve({
                        name: 'customer_contract_detail',
                        params: { userId: this.customer.id, courseId: item.id }
                    }).href;
                    window.open(url, '_blank');
                }
            } catch (error) {
                console.log("Error : " + error)
            }
        },
        async courseUpdate(){
            this.courseData.customer_id = this.customer.id;
            let haveError = false;
            await this.$axios
                .post(`/api/v1/customer_course/update/`, this.courseData)
                .then((response) => {
                    if (response.data.error) {
                        alert(response.data.error);
                        haveError = true;
                        return;
                    }
                    this.customer.contract_date = response.data.contract_date;
                    this.customer.year = response.data.year;
                    this.customer_course = response.data.customer_course;
                    this.customer_course_all = response.data.customer_course_all;
                })
                .catch((error) => {
                    console.log("Error : " + error);
                });
                
            if (haveError) {
                this.courseClose();
                return;
            }

            const existingCourseContracts = await this.$axios
                .get(`/api/v1/course-contract/customer/${this.courseData.customer_id}/existing-items`)
                .then((response) => {
                    return response.data;
                })
                .catch((error) => {
                    return error;
                });
            if (existingCourseContracts) {
                this.customer_course_all = existingCourseContracts.courses;
            }
            this.courseClose();
        },
        moveToEditContract(item) {
            this.$store.dispatch('updateContractStartDate', '');
            this.$router.push({
                name: 'customer_contract_input',
                params: { userId: this.customer.id, courseId: item.course_id },
                query: { contractId: item.id }
            });
        },
        courseOpen() {
            if(this.customer_course){
                this.courseData = {
                    course_id: this.customer_course.course_id,
                    contract_date: moment().format("YYYY/MM/DD")
                };
            } else {
                this.courseData = {
                    course_id: null,
                    contract_date: moment().format("YYYY/MM/DD"),
                }
            }
            this.courseDialog = true;
        },
        courseClose() {
            this.courseDialog = false;
        },
        checkSave() {
            this.$axios
                .put(`/api/v1/customer/${this.customer.id}/check`, { checkData: this.checkData })
                .then((response) => {
                    console.log("Updated : id=" + response.data.id);
                })
                .catch((error) => {
                    console.log("Error : " + error);
                })
                .then(() => {
                    this.customer.chk_contract.state = this.checkData.contract;
                    this.customer.chk_contract.date = this.checkData.contract_date;
                    this.customer.chk_direct_debit.state = this.checkData.direct_debit;
                    this.customer.chk_direct_debit.date = this.checkData.direct_debit_date;
                    this.customer.chk_identification.state = this.checkData.identification;
                    this.customer.chk_identification.date = this.checkData.identification_date;
                    this.customer.chk_singlecert.state = this.checkData.singlecert;
                    this.customer.chk_singlecert.date = this.checkData.singlecert_date;
                    this.customer.chk_income_cert.state = this.checkData.income_cert;
                    this.customer.chk_income_cert.date = this.checkData.income_cert_date;
                    this.customer.chk_fin_education = this.checkData.fin_education;
                    this.customer.chk_graduation_cert.state = this.checkData.graduation_cert;
                    this.customer.chk_graduation_cert.date = this.checkData.graduation_cert_date;
                    this.customer.chk_opening.state = this.checkData.opening;
                    this.customer.chk_opening.date = this.checkData.opening_date;
                });
            this.checkClose();
        },
        checkOpen() {
            this.checkData.contract = this.customer.chk_contract.state;
            this.checkData.contract_date = this.customer.chk_contract.date;
            this.checkData.direct_debit = this.customer.chk_direct_debit.state;
            this.checkData.direct_debit_date = this.customer.chk_direct_debit.date;
            this.checkData.identification = this.customer.chk_identification.state;
            this.checkData.identification_date = this.customer.chk_identification.date;
            this.checkData.singlecert = this.customer.chk_singlecert.state;
            this.checkData.singlecert_date = this.customer.chk_singlecert.date;
            this.checkData.income_cert = this.customer.chk_income_cert.state;
            this.checkData.income_cert_date = this.customer.chk_income_cert.date;
            this.checkData.fin_education = this.customer.chk_fin_education;
            this.checkData.graduation_cert = this.customer.chk_graduation_cert.state;
            this.checkData.graduation_cert_date = this.customer.chk_graduation_cert.date;
            this.checkData.opening = this.customer.chk_opening.state;
            this.checkData.opening_date = this.customer.chk_opening.date;
            this.checkDialog = true;
        },
        checkClose() {
            this.checkDialog = false;
        },
        csOpen() {
            if(this.cs_customer) {
                this.csData = {
                    born_pref: this.cs_customer.born_pref,
                    height: this.cs_customer.height,
                    weight: this.cs_customer.weight,
                    marriage: this.cs_customer.marriage,
                    child: this.cs_customer.child,
                    office_name: this.cs_customer.office_name,
                    office_name_open: this.cs_customer.office_name_open,
                    job_name: this.cs_customer.job_name,
                    annual_income: this.cs_customer.annual_income,
                    academic: this.cs_customer.academic,
                    ac_name: this.cs_customer.ac_name,
                    ac_open: this.cs_customer.ac_open,
                    smoke: this.cs_customer.smoke,
                    self_pr: this.cs_customer.self_pr,
                    relationship: this.cs_customer.relationship,
                    adoption: this.cs_customer.adoption,
                    livewith_parent: this.cs_customer.livewith_parent,
                    job_division: this.cs_customer.job_division,
                    emp_type: this.cs_customer.emp_type,
                    ind_type: this.cs_customer.ind_type,
                    occ_type: this.cs_customer.occ_type,
                    drink: this.cs_customer.drink,
                    divorce_times: this.cs_customer.divorce_times,
                    divorce_memo: this.cs_customer.divorce_memo,
                };
            } else {
                this.csData = {
                    born_pref: 0,
                    height: "",
                    weight: "",
                    marriage: -1,
                    child: false,
                    office_name: "",
                    office_name_open: false,
                    job_name: "",
                    annual_income: -1,
                    academic: 0,
                    ac_name: "",
                    ac_open: false,
                    smoke: 0,
                    self_pr: "",
                    relationship: 0,
                    adoption: 0,
                    livewith_parent: -1,
                    job_division: 0,
                    emp_type: 0,
                    ind_type: 0,
                    occ_type: 0,
                    drink: -1,
                    divorce_times: 0,
                    divorce_memo: "",
                };
            }

            this.csDialog = true;
        },
        csClose() {
            this.csDialog = false;
        },
        csSave() {
            this.$axios
                .put(`/api/v1/customer/${this.customer.id}/cs`, { csData: this.csData })
                .then((response) => {
                    console.log("Updated : id=" + response.data.id);
                })
                .catch((error) => {
                    console.log("Error : " + error);
                })
                .then(() => {
                    this.cs_customer = {
                        born_pref: this.csData.born_pref,
                        height: this.csData.height,
                        weight: this.csData.weight,
                        marriage: this.csData.marriage,
                        child: this.csData.child,
                        office_name: this.csData.office_name,
                        office_name_open: this.csData.office_name_open,
                        job_name: this.csData.job_name,
                        annual_income: this.csData.annual_income,
                        academic: this.csData.academic,
                        ac_name: this.csData.ac_name,
                        ac_open: this.csData.ac_open,
                        smoke: this.csData.smoke,
                        self_pr: this.csData.self_pr,
                        relationship: this.csData.relationship,
                        adoption: this.csData.adoption,
                        livewith_parent: this.csData.livewith_parent,
                        job_division: this.csData.job_division,
                        emp_type: this.csData.emp_type,
                        ind_type: this.csData.ind_type,
                        occ_type: this.csData.occ_type,
                        drink: this.csData.drink,
                        divorce_times: this.csData.divorce_times,
                        divorce_memo: this.csData.divorce_memo,
                    };
                });
            this.csClose();
        },
        canTest() {
            const self = this.$store.state.user;

            if(self.privilege & ACCOUNT.PRIVILEGE.VAL.SYSTEM_ADMIN) return true;
            if(self.privilege & ACCOUNT.PRIVILEGE.VAL.SEND_CS_TEST) return true;
            return false;
        },
        canProduction() {
            const self = this.$store.state.user;

            if(self.privilege & ACCOUNT.PRIVILEGE.VAL.SYSTEM_ADMIN) return true;
            if(self.privilege & ACCOUNT.PRIVILEGE.VAL.SEND_CS) return true;
            return false;
        },
        async csSendTest() {
            const res = await this.csSend('cship_test');
            if(res > 0) this.cs_customer.member_id_test = res;
        },
        async csSendProduction() {
            const res = await this.csSend('cship');
            if(res > 0) this.cs_customer.member_id = res;
        },
        async csSend(url) {
            const id = this.$route.params.id;
            const result = await this.$axios
                .get(`/api/v1/customer/${url}/${id}`)
                .then((response) => {
                    return response.data;
                })
                .catch((error) => {
                    return error;
                });
            if(result.data.status.code == 200) {
                // 成功
                alert("コネクトシップ登録完了")
                return result.data.member_id;
            } else if(result.data.status.code == 400){
                let mess = "";
                result.data.status.detail.forEach(m => {
                    mess += `${m.message}\n`;
                })
                alert(mess);
                return 0;
            }
        },
        csJumpTest() {
            window.open(`https://test-juno-dg2.c-ship.jp/member/detail/${this.cs_customer.member_id_test}/`, '_blank')
        },
        csJumpProduction() {
            window.open(`https://juno-dg2.c-ship.jp/member/detail/${this.cs_customer.member_id}/`, '_blank')
        },
        openSheet(sheet_id) {
            if(!sheet_id) return;
            window.open(`https://docs.google.com/spreadsheets/d/${sheet_id}`, '_blank')
        },
        canExit() {
            const self = this.$store.state.user;

            if(self.privilege & ACCOUNT.PRIVILEGE.VAL.SYSTEM_ADMIN) return true;
            if(self.privilege & ACCOUNT.PRIVILEGE.VAL.CUSTOMER_EXIT) return true;
            return false;
        },
        exitReserveOpen() {
            this.exitReason = 0;
            this.exitDate = null;
            this.exitReserveDialog = true;
        },
        exitReserveClose() {
            this.exitReserveDialog = false;
        },
        async exitReserveExec() {
            const id = this.$route.params.id;
            await this.$axios
                .post(`/api/v1/customer/exit_reserve/${id}`, { reason: this.exitReason, date: this.exitDate })
                .then((response) => {
                    return response.data;
                })
                .catch((error) => {
                    return error;
                });
            this.customer.is_exit_reserve = true;
            this.customer.exit_reason = this.exitReason;
            this.customer.exit_date = this.exitDate;
            this.exitReserveDialog = false;
        },
        cancelExitReserveOpen() {
            this.cancelExitReserveDialog = true;
        },
        cancelExitReserveClose() {
            this.cancelExitReserveDialog = false;
        },
        async cancelExitReserveExec() {
            const id = this.$route.params.id;
            await this.$axios
                .delete(`/api/v1/customer/exit_reserve/${id}`)
                .then((response) => {
                    return response.data;
                })
                .catch((error) => {
                    return error;
                });
            this.customer.is_exit_reserve = false;
            this.cancelExitReserveDialog = false;
        },
        exitOpen() {
            this.exitDialog = true;
        },
        exitClose() {
            this.exitDialog = false;
        },
        async exitExec() {
            const id = this.$route.params.id;
            await this.$axios
                .post(`/api/v1/customer/exit/${id}`)
                .then((response) => {
                    return response.data;
                })
                .catch((error) => {
                    return error;
                });
            this.customer.is_exit = true;
            this.exitDialog = false;
        },
        formatDate (date) {
            if (!date) return null

            try {
                const [year, month, day] = date.split('-')
                return `${year}/${month}/${day}`
            } catch {
                return null;
            }
        },
        parseDate (date) {
            if (!date) return null

            try{
                const [year, month, day] = date.split('/')
                return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
            } catch {
                return null;
            }
        },
        getListName(list, value) {
            if(!list) return "";
            const i = list.find( item => item.value == value);
            if(!i) return "";
            return i.text;
        },
        canAlter() {
            const self = this.$store.state.user;

            if(self.privilege & ACCOUNT.PRIVILEGE.VAL.SYSTEM_ADMIN) return true;
            if(self.privilege & ACCOUNT.PRIVILEGE.VAL.REQUEST_MOD_COURSE) return true;
            return false;
        },
        canEditContract(item) {
            const self = this.$store.state.user;
            
            if(self.privilege & ACCOUNT.PRIVILEGE.VAL.SYSTEM_ADMIN) return true;
            if(self.privilege & ACCOUNT.PRIVILEGE.VAL.CONTRACT_EDIT) return true;
            
            if(!item.created_at) return false;
            const createdDate = new Date(item.created_at);
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            createdDate.setHours(0, 0, 0, 0);
            
            return createdDate.getTime() === today.getTime();
        },
        alterCourseOpen() {
            window.open("https://docs.google.com/forms/d/e/1FAIpQLSdA74EUW63R42lUt8de_iJIeuPpIAsbAz36SSFOpjRAjNzgCg/viewform", '_blank');
        },
        deleteContract() {
            if(!this.idCourseCanDelete) return;

            this.$axios
                .delete(`/api/v1/customer/course/${this.customer.id}/${this.idCourseCanDelete}`)
                .then(() => {
                    this.customer_course_all = this.customer_course_all.filter((course) => {
                        return course.id !== this.idCourseCanDelete;
                    });
                    this.deleteCourseDialog = false;
                })
                .catch((error) => {
                    console.log("Error : " + error);
                });
        },
        showCourseDialog(id) {
            this.deleteCourseDialog = true;
            this.idCourseCanDelete = id;
        },
        closeDialogDeleteCourse() {
            this.deleteCourseDialog = false;
            this.idCourseCanDelete = null;
        },
    }
}
</script>
<style scoped>
.text-underline {
    text-decoration: underline;
}
</style>
